var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.$style.wrapper},[(_vm.title)?_c('h6',{staticClass:"main-title"},[_vm._t("name")],2):_vm._e(),_c('div',{class:_vm.$style.content},[_vm._t("content")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }